import { render, staticRenderFns } from "./swappHistory.vue?vue&type=template&id=f570f072&scoped=true"
import script from "./swappHistory.vue?vue&type=script&lang=js"
export * from "./swappHistory.vue?vue&type=script&lang=js"
import style0 from "./swappHistory.vue?vue&type=style&index=0&id=f570f072&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f570f072",
  null
  
)

export default component.exports